export default {
  list: require('./list').default,
  listUser: require('./listUser').default,
  create: require('./create').default,
}